// extracted by mini-css-extract-plugin
export default {"text_loading":"styles_text_loading__zMQDl"};